export default {
  namespaced: true,
  state: {
    integration1: null,
    integration2: null,
    flows: [],
    isAdmin: false,
    isPartner: false,
  },
  getters: {
    integration1: state => state.integration1,
    integration2: state => state.integration2,
    flows: state => state.flows,
    isAdmin: state => state.isAdmin,
    isPartner: state => state.isPartner,
  },
  mutations: {
    setIntegrationData(state, payload) {
      Object.assign(state, payload);
    },
  },
  actions: {
    storeIntegrationData({commit}, payload) {
      commit("setIntegrationData", payload);
    }
  },
  modules: {},
};
